import React from 'react'

import SEO from '../components/SEO'
import Support from '../components/Support'

const SupportPage: React.FC = () => (
  <>
    <SEO title="Support" />
    <Support />
  </>
)

export default SupportPage
